/**
 * Whether an API status is a success. Every 2xx is: service-voyager-api answers
 * creates with 201, which the legacy layer used to reject (it accepted only
 * 200 and 204) and report as an error with an empty message.
 */
export const isResponseOk = (status: number): boolean => status >= 200 && status < 300;
